module.exports = __webpack_public_path__ + "static/media/6.03ef033b.svg";